import React from "react";
import themeLarge from "../../../component/ThemeLarge";
import workspacePhoto from "../../../static/ideas.avif";

class GetToKnowMeMobile extends React.Component {
  render() {
    return (
      <div style={{ background: themeLarge.colors.bg, padding: "30px 20px" }}>
        {/* Heading */}
        <p
          style={{
            color: themeLarge.colors.text,
            fontSize: themeLarge.fontSize.h2,
            fontFamily: "Kumbh Sans",
            textAlign: "center",
            marginBottom: "20px",
          }}
        >
          Get to Know Me
        </p>

        {/* One-liner */}
        <p
          style={{
            fontFamily: "Kumbh Sans",
            fontSize: themeLarge.fontSize.body,
            textAlign: "center",
            marginBottom: "20px",
          }}
        >
          I like building thoughtful things with curious people.
        </p>

        {/* Tags */}
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "10px",
            justifyContent: "center",
            marginBottom: "30px",
          }}
        >
          {[
            "🎓 MSc in InfoSec (Tampere)",
            "🧠 Full-Stack @ Superwider",
            "🧘 Calm Tech Fan",
            "📊 Data Storyteller",
            "🌏 Art Curious",
            "✍️ Blogs & Reflections",
            "👓 XR Experiments",
          ].map((tag, index) => (
            <span
              key={index}
              style={{
                background: themeLarge.colors.primary,
                color: themeLarge.colors.bg,
                padding: "6px 12px",
                borderRadius: "15px",
                fontSize: "0.9rem",
              }}
            >
              {tag}
            </span>
          ))}
        </div>

        {/* Image */}
        <div style={{ textAlign: "center" }}>
          <img
            src={workspacePhoto}
            alt="A calm, minimal workspace representing a focused and thoughtful environment"
            style={{
              width: "100%",
              borderRadius: "12px",
              boxShadow: themeLarge.shadows.standard,
              marginBottom: "8px",
            }}
          />
          <p
            style={{
              fontStyle: "italic",
              fontSize: "0.85rem",
              color: themeLarge.colors.text,
            }}
          >
            Not my desk but it kind of feels like how my mind looks most days.
          </p>
        </div>

        {/* Now (bulleted) */}
        <div style={{ marginTop: "30px" }}>
          <h5
            style={{
              fontFamily: "Kumbh Sans",
              fontWeight: "bold",
              fontSize: themeLarge.fontSize.h3,
              marginBottom: "15px",
            }}
          >
            Now
          </h5>
          <ul style={{ paddingLeft: "18px", lineHeight: "1.8" }}>
            <li>
              Submitted MSc thesis:{" "}
              <em>“Cross-Platform Privacy Tool for Facebook”</em>
            </li>
            <li>Applying for graduation from Tampere University</li>
            <li>Working as a part-time full-stack dev @ Superwider</li>
            <li>
              Expanding{" "}
              <a href="https://ibtehaz.xyz" target="_blank" rel="noreferrer">
                ibtehaz.xyz
              </a>
            </li>
            <li>Exploring data storytelling, calm tech, and XR</li>
            <li>Completing Asian Studies minor at University of Turku</li>
          </ul>
        </div>
      </div>
    );
  }
}

export default GetToKnowMeMobile;
